import React, { useState } from "react";
import "./Agency_table.css";
import { useNavigate } from "react-router-dom";
import { formatOnlyAmount } from "../../../utils/common";

function Agency_table({
  register_count,
  deposit_count,
  first_deposit_count,
  User,
}) {
  const navigate = useNavigate();

  const [toastMessage, setToastMessage] = useState("");

  const copyInvitationLink = async () => {
    const link = `${process.env.REACT_APP_WEB_URL}/sign-up?ref=${User?.refer_code}`;

    await navigator.clipboard.writeText(link);

    setToastMessage(`Invitation Link Copied!`);

    setTimeout(() => {
      setToastMessage("");
    }, 3000);
  };

  return (
    <>
      <section className="Agency_table">
        <div className="commission_table_holder">
          <div class="commission-table">
            <div class="table-column">
              <h3>Direct Subordinates</h3>
              <div class="table-row">
                <p>{formatOnlyAmount(register_count)}</p>
                <span>Number of register</span>
              </div>
              <div class="table-row">
                <p class="green">{formatOnlyAmount(deposit_count)}</p>
                <span>Deposit number</span>
              </div>
              <div class="table-row">
                <p class="orange">{formatOnlyAmount(first_deposit_count)}</p>
                <span>Number of People making first deposit</span>
              </div>
            </div>

            {/* <div class="table-column">
              <h3>Team Subordinates</h3>
              <div class="table-row">
                <p>0</p>
                <span>Number of register</span>
              </div>
              <div class="table-row">
                <p class="green">0</p>
                <span>Deposit number</span>
              </div>
              <div class="table-row">
                <p class="orange">0</p>
                <span>Number of People making first deposit</span>
              </div>
            </div> */}
          </div>
          {/* <button
            className="btn_register_bg"
            onClick={() => {
              if (User) copyInvitationLink();
            }}
          >
            INVITATION LINK
          </button> */}

          {toastMessage && (
            <span
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                background: "#000000b9",
                color: "#fff",
                padding: "12px 16px",
                fontSize: "14px",
                borderRadius: "6px",
                zIndex: 9999,
                maxWidth: "90%",
                textAlign: "center",
                whiteSpace: "pre-wrap",
                wordBreak: "break-all",
              }}
            >
              {toastMessage}
            </span>
          )}
        </div>
      </section>
    </>
  );
}

export default Agency_table;
